import { ITableItemSkillLevel } from '@components/progress/table/TableItem';

export function masteryTopicRandomizer(topics: ITableItemSkillLevel[]) {
  const randomizedTopic: ITableItemSkillLevel[] = [];

  topics.forEach(item => {
    randomizedTopic.push({
      ...item,
      skillLevel: Math.round(3 + Math.random() * 7),
    });
  });

  return randomizedTopic;
}

/**
 * randomizer for graph, let's try to make a smooth transition between graph data point for a good representative of student progress
 * @param range
 * @param lastData
 */
export function masteryGraphRandomizer(range: number, lastData: number) {
  const data: number[] = [];

  let scoreBefore: number = lastData;
  let changeCounter = Math.round(1 + Math.random() * 3);
  for (let i = 0; i <= range; i++) {
    if (i == 0) {
      data.unshift(lastData);
      continue;
    }

    // let's make the graph have a same value for a few days, it is a better representative of student progress
    if (changeCounter > 0) {
      data.unshift(scoreBefore);
      changeCounter--;
      continue;
    }

    // this will make a higher value will have a bigger chance for lower value for the next data
    let multiplier = Math.random() > scoreBefore / 10 ? 1 : -1;
    // let's make the graph between 2 - 10, I think it will appear more beautifully like that
    if (scoreBefore == 10) {
      multiplier = -1;
    } else if (scoreBefore <= 2) {
      multiplier = 1;
    }

    const difference = 1 + (Math.random() > 0.75 ? 1 : 0);

    const dataPoint = scoreBefore + multiplier * difference;
    scoreBefore = dataPoint;
    changeCounter = Math.round(1 + Math.random() * 5);
    data.unshift(dataPoint);
  }

  return data;
}
